"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusWithinContainer = void 0;
const styled_1 = __importDefault(require("../../styles/styled"));
const theme_1 = require("../../styles/theme");
const layout_1 = require("../layout");
exports.FocusWithinContainer = (0, styled_1.default)(layout_1.Box)({
    width: '100%',
    ':focus-within': theme_1.focus.shadow,
});
//# sourceMappingURL=focus_within_container.js.map